/**
 * @description 投保人數用
*/
export enum InsCount {
  /** 一人投保 */
  One = 'INSUREDSUBJECTO',
  /** 多人投保 */
  MORE ='INSUREDSUBJECTM'
}
